export default "__VITE_ASSET__D_0yzcDX__"